import useSWR, { mutate as globalMutate } from "swr";
import { API } from "../utils/constants";
import { authFetcher } from "./fetcher";

/**
 * useAdminUsers — Fetches admin users for lifecycle management (SPR-007).
 *
 * API: GET /api/admin/users → AdminUserDto[] (CON-002 §9A entity lifecycle).
 * Each user exposes derived `isActive` (DeactivatedAt == null) and
 * `isProtected` (the seeded main admin cannot be deactivated/deleted).
 * Requires Bearer token (authed fetcher, DEF-010).
 *
 * @returns {{ users: Array, error: any, isLoading: boolean, mutate: Function }}
 */
export function useAdminUsers() {
  const { data, error, isLoading, mutate } = useSWR(
    API.ADMIN.USERS.LIST,
    authFetcher,
    { revalidateOnFocus: false }
  );

  return { users: data ?? [], error, isLoading, mutate };
}

/**
 * invalidateAdminUsers — Force-revalidates the admin users SWR cache.
 * @returns {Promise<any>}
 */
export const invalidateAdminUsers = () => globalMutate(API.ADMIN.USERS.LIST);
